import axios from "axios"
import Cookies from "js-cookie"

export const baseURL = "https://api.abidebudget.com:443/"
export const timeout = 15000

const instance = axios.create({
  baseURL,
  timeout,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
})

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

const unauthenticatedRoutes = [
  "auth/abide/login",
  "abide/auth/v1/initiate-reset/",
  "abide/auth/v1/validate-reset/",
  "abide/auth/v1/reset-password",
  "/abide/auth/v1/donations",
]

const isWhitelisted = (url) => {
  return unauthenticatedRoutes.some((route) => url.includes(route))
}

const refreshToken = async () => {
  try {
    const response = await axios.post(
      `${baseURL}auth/abide/refresh`,
      {},
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    return response?.status === 200
  } catch {
    return false
  }
}

const logoutUser = async () => {
  try {
    const res = await axios.post(
      `${baseURL}auth/abide/logout`,
      {},
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    if (res) {
      Cookies.remove("_k")
      Cookies.remove("_XFRSH")
      Cookies.remove("XFRSH")
      Cookies.remove("BAMBOO")
      Cookies.remove("LILBAMBOO")
      sessionStorage.removeItem("addeditem")
    }
  } catch (err) {}
}

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !isWhitelisted(originalRequest.url)
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject })
        })
          .then(() => instance(originalRequest))
          .catch((err) => Promise.reject(err))
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        const refreshed = await refreshToken()

        if (refreshed) {
          processQueue(null)
          return instance(originalRequest)
        } else {
          throw new Error("Refresh token failed")
        }
      } catch (refreshError) {
        processQueue(refreshError)
        await logoutUser()
        window.location.href = "/unauthorized"
        return Promise.reject(refreshError)
      } finally {
        isRefreshing = false
      }
    }

    return Promise.reject(error)
  }
)

export default instance
